export const SCROLL_OFFSET = 100;

export const normalizePath = (path) => {
  const normalized = path.replace(/\/$/, "");
  return normalized || "/";
};

export const parseAnchorHref = (href) => {
  if (!href || href === "#") return null;

  if (href.startsWith("#")) {
    return { pathname: normalizePath(window.location.pathname), hash: href.slice(1) };
  }

  try {
    const url = new URL(href, window.location.origin);
    return {
      pathname: normalizePath(url.pathname),
      hash: url.hash ? url.hash.slice(1) : "",
    };
  } catch {
    return null;
  }
};

export const scrollToAnchor = (anchorId, { updateHash = true } = {}) => {
  if (typeof window === "undefined" || !anchorId) return false;

  const target = document.getElementById(anchorId);
  if (!target) return false;

  const top =
    target.getBoundingClientRect().top + window.scrollY - SCROLL_OFFSET;
  window.scrollTo({ top, behavior: "auto" });

  if (updateHash) {
    window.history.replaceState(null, "", `#${anchorId}`);
  }

  return true;
};

export const bindInstantAnchorScroll = () => {
  if (typeof document === "undefined") return;

  document.addEventListener(
    "click",
    (event) => {
      const link = event.target.closest('a[href*="#"]');
      if (!link) return;

      const parsed = parseAnchorHref(link.getAttribute("href"));
      if (!parsed?.hash) return;

      const currentPath = normalizePath(window.location.pathname);
      if (currentPath !== parsed.pathname) return;

      if (!document.getElementById(parsed.hash)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      scrollToAnchor(parsed.hash);
    },
    true
  );
};

export const scrollToRouteHash = (hash) => {
  if (!hash) return;

  const anchorId = hash.replace("#", "");
  if (!anchorId) return;

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      scrollToAnchor(anchorId, { updateHash: false });
    });
  });
};
